<terra-dialog-header>
  <div class="title">
    <h1>Send a Payment</h1>
    <p>Choose the type of transfer you'd like to send to vendor</p>
  </div>
</terra-dialog-header>

<mat-dialog-content>
  <div class="dialog-content">
    <!--  ACH  -->
    <div class="payment-type-card">
      <mat-icon class="notranslate">multiple_stop</mat-icon>
      <span class="type-title">ACH Payment</span>
      <p class="type-description">Quick, convenient, secure way of<br /> sending or requesting funds.</p>
      <a mat-stroked-button class="button" (click)="createPayment(CrePaymentType.Ach)">Send ACH Payment</a>
    </div>
    <!--  Wire  -->
    <div class="payment-type-card">
      <mat-icon class="notranslate">price_change</mat-icon>
      <span class="type-title">Wire Payment</span>
      <p class="type-description">If the funds need to be sent <br /> immediately.</p>
      <button mat-stroked-button class="button" (click)="createPayment(CrePaymentType.Wire)">Send Wire Payment</button>
    </div>
  </div>
</mat-dialog-content>
